import Error from "@components/Error";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { Outlet, useNavigate } from "react-router-dom";

const Fallback = ({ error, resetErrorBoundary }: FallbackProps) => {
  const { t } = useTranslation();
  return (
    <Error onAgain={resetErrorBoundary} buttonTitle={t<string>("Back")}>
      {error.message}
    </Error>
  );
};

const ErrorBoundaryLayout = () => {
  const navigate = useNavigate();
  return (
    <ErrorBoundary FallbackComponent={Fallback} onReset={() => navigate(-1)}>
      <Outlet />
    </ErrorBoundary>
  );
};

export default ErrorBoundaryLayout;
